var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("el-alert", {
        staticStyle: { "margin-bottom": "16px" },
        attrs: {
          title: _vm.$t("subscriptionAudit.devToolTitle"),
          type: "warning",
          description: _vm.$t("subscriptionAudit.devToolDescription"),
          "show-icon": "",
          closable: false,
        },
      }),
      _c(
        "el-card",
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [
              _c("b", [
                _vm._v(_vm._s(_vm.$t("subscriptionAudit.runNewAudit"))),
              ]),
            ]),
          ]),
          _c(
            "el-form",
            { attrs: { inline: "", model: _vm.runForm } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Platforms" } },
                [
                  _c(
                    "el-checkbox-group",
                    {
                      model: {
                        value: _vm.runForm.platforms,
                        callback: function ($$v) {
                          _vm.$set(_vm.runForm, "platforms", $$v)
                        },
                        expression: "runForm.platforms",
                      },
                    },
                    [
                      _c("el-checkbox", { attrs: { label: "ios" } }, [
                        _vm._v("iOS"),
                      ]),
                      _c("el-checkbox", { attrs: { label: "android" } }, [
                        _vm._v("Android"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("subscriptionAudit.lookbackDays") } },
                [
                  _c("el-input-number", {
                    attrs: { min: 7, max: 365, step: 30 },
                    model: {
                      value: _vm.runForm.sinceDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.runForm, "sinceDays", $$v)
                      },
                      expression: "runForm.sinceDays",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("subscriptionAudit.maxSubs") } },
                [
                  _c("el-input-number", {
                    attrs: { min: 100, max: 5000, step: 100 },
                    model: {
                      value: _vm.runForm.maxSubs,
                      callback: function ($$v) {
                        _vm.$set(_vm.runForm, "maxSubs", $$v)
                      },
                      expression: "runForm.maxSubs",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.running },
                      on: { click: _vm.onRunAudit },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("subscriptionAudit.startAudit")) +
                          " "
                      ),
                    ]
                  ),
                  _c("el-button", { on: { click: _vm.loadSummary } }, [
                    _vm._v(_vm._s(_vm.$t("subscriptionAudit.refreshSummary"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c("div", { staticStyle: { "font-size": "12px", color: "#999" } }, [
            _vm._v(" " + _vm._s(_vm.$t("subscriptionAudit.asyncNote")) + " "),
          ]),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "16px" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("b", [_vm._v(_vm._s(_vm.$t("subscriptionAudit.recentRuns")))]),
          ]),
          _c(
            "el-table",
            { attrs: { data: _vm.summary.runs, size: "mini", border: "" } },
            [
              _c("el-table-column", {
                attrs: {
                  label: "Run ID",
                  prop: "audit_run_id",
                  "min-width": "280",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                _vm.filter.auditRunId = row.audit_run_id
                                _vm.loadFindings()
                              },
                            },
                          },
                          [_vm._v(_vm._s(row.audit_run_id))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.started"),
                  prop: "started",
                  width: "170",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_vm.formatDate(row.started)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.colFindings"),
                  prop: "findings",
                  width: "80",
                  align: "right",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Critical",
                  prop: "critical",
                  width: "90",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        Number(row.critical) > 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "danger", size: "mini" } },
                              [_vm._v(_vm._s(row.critical))]
                            )
                          : _c("span", [_vm._v("0")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "High",
                  prop: "high",
                  width: "80",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        Number(row.high) > 0
                          ? _c(
                              "el-tag",
                              { attrs: { type: "warning", size: "mini" } },
                              [_vm._v(_vm._s(row.high))]
                            )
                          : _c("span", [_vm._v("0")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Medium",
                  prop: "medium",
                  width: "80",
                  align: "right",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Low",
                  prop: "low",
                  width: "80",
                  align: "right",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.open"),
                  prop: "unresolved",
                  width: "80",
                  align: "right",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "16px" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("b", [_vm._v(_vm._s(_vm.$t("subscriptionAudit.openByType")))]),
          ]),
          _c(
            "el-table",
            {
              attrs: { data: _vm.summary.openByType, size: "mini", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.type"),
                  prop: "finding_type",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Severity", prop: "severity", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.severityTagType(row.severity),
                            },
                          },
                          [_vm._v(_vm._s(row.severity))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Platform", prop: "platform", width: "100" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.count"),
                  prop: "count",
                  width: "100",
                  align: "right",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "16px" } },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("b", [
              _vm._v(_vm._s(_vm.$t("subscriptionAudit.findingsTitle"))),
            ]),
          ]),
          _c(
            "el-form",
            { attrs: { inline: "", model: _vm.filter, size: "mini" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Run ID" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "280px" },
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.filter.auditRunId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "auditRunId", $$v)
                      },
                      expression: "filter.auditRunId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Platform" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "110px" },
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.filter.platform,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "platform", $$v)
                        },
                        expression: "filter.platform",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "iOS", value: "ios" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Android", value: "android" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("subscriptionAudit.type") } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "240px" },
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.filter.findingType,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "findingType", $$v)
                        },
                        expression: "filter.findingType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: {
                          label: "missing_entitlement",
                          value: "missing_entitlement",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "feature_mismatch",
                          value: "feature_mismatch",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "expiry_mismatch",
                          value: "expiry_mismatch",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "store_expired_db_active",
                          value: "store_expired_db_active",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "store_refunded_db_active",
                          value: "store_refunded_db_active",
                        },
                      }),
                      _c("el-option", {
                        attrs: { label: "dual_account", value: "dual_account" },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "orphan_no_user",
                          value: "orphan_no_user",
                        },
                      }),
                      _c("el-option", {
                        attrs: {
                          label: "store_api_error",
                          value: "store_api_error",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Severity" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { clearable: "" },
                      model: {
                        value: _vm.filter.severity,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "severity", $$v)
                        },
                        expression: "filter.severity",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "critical", value: "critical" },
                      }),
                      _c("el-option", {
                        attrs: { label: "high", value: "high" },
                      }),
                      _c("el-option", {
                        attrs: { label: "medium", value: "medium" },
                      }),
                      _c("el-option", {
                        attrs: { label: "low", value: "low" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Email" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.filter.userEmail,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "userEmail", $$v)
                      },
                      expression: "filter.userEmail",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "UserId" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "220px" },
                    attrs: { clearable: "" },
                    model: {
                      value: _vm.filter.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.filter, "userId", $$v)
                      },
                      expression: "filter.userId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.filter.unresolved,
                        callback: function ($$v) {
                          _vm.$set(_vm.filter, "unresolved", $$v)
                        },
                        expression: "filter.unresolved",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("subscriptionAudit.openOnly")))]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.loadFindings },
                    },
                    [_vm._v(_vm._s(_vm.$t("subscriptionAudit.filter")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { size: "mini" }, on: { click: _vm.resetFilter } },
                    [_vm._v(_vm._s(_vm.$t("subscriptionAudit.reset")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingFindings,
                  expression: "loadingFindings",
                },
              ],
              attrs: { data: _vm.findings, size: "mini", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "ID", prop: "id", width: "70" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.type"),
                  prop: "findingType",
                  "min-width": "180",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              size: "mini",
                              type: _vm.severityTagType(row.severity),
                            },
                          },
                          [_vm._v(_vm._s(row.severity))]
                        ),
                        _c("span", { staticStyle: { "margin-left": "6px" } }, [
                          _vm._v(_vm._s(row.findingType)),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Platform", prop: "platform", width: "80" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "Email",
                  prop: "userEmail",
                  "min-width": "180",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "UserId", prop: "userId", width: "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("code", { staticStyle: { "font-size": "11px" } }, [
                          _vm._v(
                            _vm._s((row.userId || "").substring(0, 12)) +
                              _vm._s(
                                row.userId && row.userId.length > 12 ? "…" : ""
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Source Reference", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("code", { staticStyle: { "font-size": "11px" } }, [
                          _vm._v(
                            _vm._s(
                              (row.sourceReference || "").substring(0, 24)
                            ) +
                              _vm._s(
                                row.sourceReference &&
                                  row.sourceReference.length > 24
                                  ? "…"
                                  : ""
                              )
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.product"),
                  prop: "productId",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.expectedActual"),
                  "min-width": "240",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("span", { staticStyle: { color: "#67C23A" } }, [
                          _vm._v(
                            _vm._s(
                              (row.expectedFeatures || []).join(", ") || "-"
                            )
                          ),
                        ]),
                        _c(
                          "span",
                          { staticStyle: { color: "#999", margin: "0 4px" } },
                          [_vm._v("→")]
                        ),
                        _c("span", { staticStyle: { color: "#F56C6C" } }, [
                          _vm._v(
                            _vm._s((row.actualFeatures || []).join(", ") || "-")
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.storeDbExpiry"),
                  "min-width": "240",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("div", { staticStyle: { "font-size": "11px" } }, [
                          _vm._v(
                            "Store: " +
                              _vm._s(_vm.formatDate(row.expectedExpires))
                          ),
                        ]),
                        _c("div", { staticStyle: { "font-size": "11px" } }, [
                          _vm._v(
                            "DB: " + _vm._s(_vm.formatDate(row.actualExpires))
                          ),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.storeStatus"),
                  prop: "storeStatus",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.date"),
                  width: "140",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(_vm._s(_vm.formatDate(row.createdAt)))]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.status"),
                  width: "160",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        row.resolvedAt
                          ? _c(
                              "el-tag",
                              { attrs: { type: "success", size: "mini" } },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("subscriptionAudit.resolved"))
                                ),
                              ]
                            )
                          : _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.resolve(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("subscriptionAudit.markResolved")
                                  )
                                ),
                              ]
                            ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("subscriptionAudit.details"),
                  width: "80",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.showDetails(row)
                              },
                            },
                          },
                          [_vm._v("JSON")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: {
              total: _vm.total,
              page: _vm.filter.page,
              limit: _vm.filter.limit,
            },
            on: {
              "update:page": function ($event) {
                return _vm.$set(_vm.filter, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.filter, "limit", $event)
              },
              pagination: _vm.loadFindings,
            },
          }),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("subscriptionAudit.findingDetails"),
            visible: _vm.detailVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailVisible = $event
            },
          },
        },
        [
          _c(
            "pre",
            {
              staticStyle: {
                "max-height": "600px",
                overflow: "auto",
                "font-size": "11px",
                background: "#f5f5f5",
                padding: "12px",
              },
            },
            [_vm._v(_vm._s(_vm.detailJson))]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }